import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

export function SecretChatAdmin() {
  const [list, setList] = useState(null);
  const load = () => api.get("/secretchat/admin/reports").then(({ data }) => setList(data)).catch(() => setList([]));
  useEffect(() => { load(); }, []);
  const close = async (id, endChat) => {
    try { await api.post(`/secretchat/admin/reports/${id}/close?end_chat=${endChat}`); toast.success(endChat ? "Chat beendet" : "Meldung erledigt"); load(); } catch (e) { toast.error(formatErr(e)); }
  };
  if (!list) return null;
  if (!list.length) return <p className="text-sm text-slate-400" data-testid="secret-admin-empty">Keine offenen Meldungen aus heimlichen Chats.</p>;
  return (
    <ul className="space-y-4 max-w-3xl" data-testid="secret-admin">
      {list.map((r) => (
        <li key={r.id} className="bg-white rounded-3xl border border-pink-100 p-4 space-y-3" data-testid={`secret-admin-report-${r.id}`}>
          <p className="text-sm"><b>Gemeldet</b> {new Date(r.created_at).toLocaleString("de-DE")}{r.reason && <> · „{r.reason}“</>}</p>
          <p className="text-xs text-slate-500">Nur für Moderatoren sichtbar: {r.members.map((m) => `${m.name} (${m.alias})`).join(" ↔ ")}</p>
          <div className="max-h-64 overflow-y-auto space-y-1 rounded-2xl bg-slate-50 p-3 text-sm">
            {r.messages.map((m, i) => <p key={i} className={m.flagged ? "text-rose-600" : ""}><b>{m.sender}:</b> {m.text}{m.flagged && " (ausgeblendet)"}</p>)}
          </div>
          <div className="flex flex-wrap gap-2">
            <button onClick={() => close(r.id, false)} data-testid={`secret-admin-ok-${r.id}`} className="h-10 px-4 rounded-full bg-slate-100 text-sm font-bold">Alles ok</button>
            <button onClick={() => close(r.id, true)} data-testid={`secret-admin-end-${r.id}`} className="h-10 px-4 rounded-full bg-rose-500 text-white text-sm font-bold">Chat beenden</button>
          </div>
        </li>
      ))}
    </ul>
  );
}
